import { Button, Image } from "@chakra-ui/react";
import { logEvent } from "firebase/analytics";
import { useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from "react-router-dom";
import { analytics } from "../firebase";
import { Helmet } from "react-helmet";
import ram from "./arapawa ram4.png";
import thar from "./Bull thar white.png";
import chamois from "./chamois white transparent.png";
import fallow from "./fallow.png";
import goat from "./Goat Tile.png";
import image from "./nz country red deer.png";
import { useAtom } from "jotai";
import { windowSizeState } from "../jotai";

export const TrophyHunting = () => {
  const [size] = useAtom(windowSizeState);
  const nav = useNavigate();

  useEffect(() => {
    logEvent(analytics, "page_view", { page_title: "Trophy Hunting" });
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Guided Trophy Hunting in New Zealand",
    url: "https://www.nzcountry.guide/trophy-hunting-new-zealand",
    image:
      "https://firebasestorage.googleapis.com/v0/b/nzcountry.appspot.com/o/images%2FJim%20and%20Mark_5.10.1.jpg?alt=media",
    description:
      "Hunt for trophy Red Deer,Red Stags, Fallow Deer, Feral Goats, Himalayan Tahr, and Arapawa Rams in the South Island wilderness of New Zealand.",
    brand: {
      "@type": "Brand",
      name: "NZ COUNTRY",
    },
    makesOffer: [
      {
        "@type": "Offer",
        name: "Guided Tahr Hunt",
        itemOffered: {
          "@type": "Service",
          name: "Guided Tahr Hunting Expedition",
          serviceType: "Guided Hunting",
          description:
            "Experience a challenging and rewarding guided hunt for Himalayan Tahr in New Zealand's spectacular Southern Alps.",
          category: "Big Game Hunting",
          areaServed: {
            "@type": "Place",
            name: "Southern Alps, New Zealand",
          },
          keywords:
            "Tahr hunting, guided tahr hunt, New Zealand big game, alpine hunting, Himalayan Tahr, helicopter flight, trophy tahr",
        },
        availability: "https://schema.org/InStock", // Or specific dates/seasons
        priceCurrency: "USD", // Optional: if you list specific prices
      },
      {
        "@type": "Offer",
        name: "Guided Chamois Hunt",
        itemOffered: {
          "@type": "Service",
          name: "Guided Chamois Hunting Adventure",
          serviceType: "Guided Hunting",
          description:
            "Pursue the agile and elusive Chamois with experienced guides in New Zealand's rugged high-country.",
          category: "Big Game Hunting",
          areaServed: {
            "@type": "Place",
            name: "High Country, South Island, New Zealand",
          },
          keywords:
            "Chamois hunting, guided chamois hunt, New Zealand alpine hunting, trophy chamois",
        },
        availability: "https://schema.org/InStock",
        priceCurrency: "USD",
      },
      {
        "@type": "Offer",
        name: "Guided Goat Hunt",
        itemOffered: {
          "@type": "Service",
          name: "Guided Goat Hunting Trip",
          serviceType: "Guided Hunting",
          description:
            "Enjoy a thrilling guided goat hunt, targeting feral goats in diverse New Zealand terrain. Suitable for all experience levels.",
          category: "Hunting",
          areaServed: {
            "@type": "Place",
            name: "Various Locations, New Zealand",
          },
          keywords:
            "Goat hunting, guided goat hunt, feral goat, New Zealand hunting, trophy goat",
        },
        availability: "https://schema.org/InStock",
        priceCurrency: "USD",
      },
      {
        "@type": "Offer",
        name: "Guided Arapawa Ram Hunt",
        itemOffered: {
          "@type": "Service",
          name: "Guided Arapawa Ram Hunting",
          serviceType: "Guided Hunting",
          description:
            "Hunt the unique and historic Arapawa Ram with our specialized guided services in New Zealand.",
          category: "Specialty Hunting",
          areaServed: {
            "@type": "Place",
            name: "Select locations, South Island, New Zealand",
          },
          keywords:
            "Arapawa Ram hunting, guided ram hunt, New Zealand heritage breed, trophy ram",
        },
        availability: "https://schema.org/InStock",
        priceCurrency: "USD",
      },
      {
        "@type": "Offer",
        name: "Guided Red Deer Hunt",
        itemOffered: {
          "@type": "Service",
          name: "Guided Red Deer Stag Hunt",
          serviceType: "Guided Hunting",
          description:
            "Track and hunt magnificent Red Stags with our expert guides in prime New Zealand deer habitat, especially during the roar.",
          category: "Big Game Hunting",
          areaServed: {
            "@type": "Place",
            name: "Prime Deer Habitat, New Zealand", // e.g., Fiordland, West Coast, private estates
          },
          keywords:
            "Red Deer hunting, guided stag hunt, New Zealand red stag, the roar, trophy deer, Douglas score, SCI score, trophy stag",
        },
        availability: "https://schema.org/InStock",
        priceCurrency: "USD",
      },
      {
        "@type": "Offer",
        name: "Guided Fallow Deer Hunt",
        itemOffered: {
          "@type": "Service",
          name: "Guided Fallow Buck Hunt",
          serviceType: "Guided Hunting",
          description:
            "Pursue impressive Fallow Bucks with our guided hunts in select New Zealand locations known for quality Fallow Deer.",
          category: "Big Game Hunting",
          areaServed: {
            "@type": "Place",
            name: "West Coast, South Island, New Zealand",
          },
          keywords:
            "Fallow Deer hunting, guided fallow buck hunt, New Zealand fallow deer, trophy buck",
        },
        availability: "https://schema.org/InStock",
        priceCurrency: "USD",
      },
    ],
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <div
        style={{
          height: "100vh",
          overflowY: "hidden",
          backgroundColor: "rgba(0,0,0,.4)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: size.width < 930 ? "row" : "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: size.width < 930 ? "column" : "row",
                    alignItems: "center",
                  }}
                >
                  <Image
                    src={image}
                    width={size.width < 930 ? 100 : 200}
                    style={{ cursor: "pointer", opacity: ".8" }}
                    onClick={() => nav("/red-deer-trophy-hunting-new-zealand")}
                  />
                  <Image
                    src={thar}
                    width={size.width < 930 ? 100 : 200}
                    style={{ cursor: "pointer", opacity: ".8" }}
                    onClick={() => nav("/tahr-hunting-new-zealand")}
                  />
                  <Image
                    src={chamois}
                    width={size.width < 930 ? 100 : 200}
                    style={{ cursor: "pointer", opacity: ".8" }}
                    onClick={() => nav("/chamois-hunting-new-zealand")}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: size.width < 930 ? "column" : "row",
                    alignItems: "center",
                  }}
                >
                  <Image
                    src={fallow}
                    width={size.width < 930 ? 100 : 200}
                    style={{ cursor: "pointer", opacity: ".8" }}
                    onClick={() => nav("/fallow-deer-hunting-new-zealand")}
                  />
                  <Image
                    src={ram}
                    width={size.width < 930 ? 100 : 200}
                    style={{ cursor: "pointer", opacity: ".8" }}
                    onClick={() => nav("/arapawa-ram-hunting-new-zealand")}
                  />
                  <Image
                    src={goat}
                    width={size.width < 930 ? 100 : 200}
                    style={{ cursor: "pointer", opacity: ".8" }}
                    onClick={() => nav("/goat-hunting-new-zealand")}
                  />
                </div>
              </div>
              <Button
                size="lg"
                variant={"link"}
                onClick={() => nav("/")}
                color={"#EA9101"}
                fontFamily={"anton"}
                letterSpacing={1.5}
              >
                HOME
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
